import { render } from "./DefaultPageHeader.vue?vue&type=template&id=25ac4529"
import script from "./DefaultPageHeader.vue?vue&type=script&lang=js"
export * from "./DefaultPageHeader.vue?vue&type=script&lang=js"
script.render = render

export default script